import { Pipe, PipeTransform } from '@angular/core';
import { AccountTransactionReason } from 'src/app/models/enums/account-transaction-reason';

@Pipe({
  name: 'reasonType'
})
export class ReasonTypePipe implements PipeTransform {

  transform(value: AccountTransactionReason, ...args: number[]): string {
    
    switch (value) {
      case AccountTransactionReason.Deposit:
        return 'Gelen'
      case AccountTransactionReason.Withdraw:
        return 'Çıkan'
      case AccountTransactionReason.Exchange:
        return 'Alım/Satım'
      case AccountTransactionReason.ExchangeCancel:
        return 'Alım/Satım İptal'
      case AccountTransactionReason.BranchTransfer:
        return 'Şubeye Transfer'
      case AccountTransactionReason.BranchMoneyEntry:
        return 'Para Girişi'
      case AccountTransactionReason.BranchMoneyExit:
        return 'Para Çıkışı'
      case AccountTransactionReason.Collection:
        return 'Tahsilat'
      case AccountTransactionReason.Virman:
        return 'Virman'
      case AccountTransactionReason.Sales:
        return 'Perakende Satış'
      case AccountTransactionReason.ProductionCost:
        return 'Üretim'
      case AccountTransactionReason.RawMaterialPurchase:
        return 'Hammadde Satış'
      case AccountTransactionReason.ProductPurchase:
        return 'Ürün Tedariği'
      // Aşağıdakiler eksikti; boş dönüyordu. Banka hareketinden doğan hesap
      // hareketlerinin sebebi hemen her zaman bu kümeden geliyor.
      case AccountTransactionReason.CaseCounting:
        return 'Kasa Sayımı'
      case AccountTransactionReason.Expense:
        return 'Gider'
      case AccountTransactionReason.Income:
        return 'Gelir'
      case AccountTransactionReason.Import:
        return 'Devir'
      case AccountTransactionReason.BankAccountTransaction:
        return 'Banka Hareketi'
      case AccountTransactionReason.TcknVknMatch:
        return 'VKN/TCKN Eşleşmesi'
      case AccountTransactionReason.BankPayment:
        return 'Havale/EFT Ödemesi'
      case AccountTransactionReason.IbanMatch:
        return 'IBAN Eşleşmesi'
      case AccountTransactionReason.BankAutoCustomer:
        return 'Otomatik Müşteri (Banka)'
      case AccountTransactionReason.BankManualMatch:
        return 'Elle Eşleştirme (Banka)'
      case AccountTransactionReason.NameMatch:
        return 'Ad Eşleşmesi (Banka)'
      case AccountTransactionReason.BankOpeningBalance:
        return 'Banka Açılış Bakiyesi'
      case AccountTransactionReason.ProductTransfer:
        return 'Ürüne Aktarım'
      case AccountTransactionReason.BulkPurchase:
        return 'Mal Girişi'
      default:
        // Tanımsız bir sebep geldiğinde hücre undefined basmasın
        return ''
    }
  }

}
